import { Link } from "react-router-dom";
import { LegalShell, Section, UPDATED } from "@/pages/Legal";

const Mail = () => <a href="mailto:shaurya@sanghviinfo.com" className="text-[#B8A4FF] hover:underline" data-testid="grievance-email">shaurya@sanghviinfo.com</a>;

export default function Grievance() {
  return (
    <LegalShell eyebrow="LEGAL" title="Grievance redressal" updated={UPDATED} testid="grievance-page"
      seo={{ title: "Grievance Officer", description: "Contact Studivault's Grievance Officer under the IT Rules 2011/2021, DPDP Act 2023 and Consumer Protection (E-Commerce) Rules 2020.", path: "/grievance" }}>
      <p>
        In accordance with the Information Technology Act, 2000, the IT Rules, 2011 and 2021, the Digital
        Personal Data Protection Act, 2023 and the Consumer Protection (E-Commerce) Rules, 2020, the details of
        our Grievance Officer are below.
      </p>

      <Section n={1} title="Grievance Officer">
        <div className="surface p-5 space-y-1" data-testid="grievance-officer-card">
          <div><strong>Name:</strong> Shaurya Sanghvi</div>
          <div><strong>Organisation:</strong> Bloc Metric (operator of Studivault, studivault.com)</div>
          <div><strong>Country:</strong> India</div>
          <div><strong>Email:</strong> <Mail /></div>
        </div>
      </Section>

      <Section n={2} title="What you can raise">
        Complaints about content on the Service, privacy or personal data (including DPDP Act rights requests),
        account or security issues, payments and refunds, intellectual property infringement, or any breach of
        our <Link to="/terms" className="text-[#B8A4FF] hover:underline">Terms</Link>.
      </Section>

      <Section n={3} title="How to file">
        Email <Mail /> with your name, account email, a description of the issue, relevant links or order IDs,
        and any supporting documents. For content complaints, include the URL or pack name.
      </Section>

      <Section n={4} title="Timelines">
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Acknowledgement within <strong>24 hours</strong> (48 hours for consumer complaints).</li>
          <li>Resolution within <strong>15 days</strong> of receipt.</li>
          <li>Requests to remove content that exposes a person's private area, nudity, sexual act or impersonation will be acted on within <strong>24 hours</strong>.</li>
        </ul>
      </Section>

      <Section n={5} title="Escalation">
        If you are not satisfied with the resolution of a personal data grievance, you may approach the Data
        Protection Board of India. Consumer complaints may also be filed with the National Consumer Helpline
        (1915 / consumerhelpline.gov.in) or the appropriate Consumer Commission.
      </Section>
    </LegalShell>
  );
}
